"use client";

import { useTheme } from "next-themes";
import { Toaster as Sonner, ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  const { resolvedTheme } = useTheme();
  const sonnerTheme: ToasterProps["theme"] = resolvedTheme === "dark" ? "dark" : "light";

  return (
    <Sonner
      theme={sonnerTheme}
      className="toaster group"
      style={
        {
          "--normal-bg": "var(--toaster-bg)",
          "--normal-text": "var(--toaster-text)",
          "--normal-border": "var(--border)",
          "--success-bg": "var(--toaster-bg)",
          "--success-text": "var(--toaster-text)",
          "--success-border": "var(--border)",
          "--error-bg": "var(--toaster-fail-bg)",
          "--error-text": "var(--toaster-fail-text)",
          "--error-border": "var(--border)",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
